import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem3,
    GridItem8,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    RichTextEditorPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorPadrao'

import {
    IconButtonClearEntradaDados,
    IconButtonMoveParaCimaParaBaixo,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'



const AcompanhamentoFormAnotacoes = ( { values, handleChange, handleSubmit, setFieldValue } ) => {

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <FieldArray name="anotacoes">
                {(arrayHelpers) => (
                    <DivForm>
                        <DivForm>
                            {values.anotacoes?.map((item, ind) => {

                                return (
                                    <GridContainer
                                        key={ind}
                                    >
                                        <GridItem12>
                                            <CardGridEntradaDados>
                                                <CardGridDivBodyEntradaDados>
                                                    <GridContainer>
                                                        <GridItem8>
                                                            <TextValidatorText
                                                                name={`anotacoes[${ind}].tituloAnotacao`}
                                                                label={LABEL.tituloAnotacao}
                                                                value={item.tituloAnotacao || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.tituloAnotacao}
                                                                notToUpperCase={true}
                                                                disabled={values.ultimaVersao !== values.versao}
                                                            />
                                                        </GridItem8>

                                                        <GridItem3>
                                                            <MuiPickersUtilsProviderPadrao>
                                                                <KeyboardDatePickerPadrao
                                                                    name={`anotacoes[${ind}].dataAnotacao`}
                                                                    label={LABEL.dataAnotacao}
                                                                    value={item.dataAnotacao}
                                                                    onChange={(date) => {
                                                                        setFieldValue(
                                                                            `anotacoes[${ind}].dataAnotacao`,
                                                                            date,
                                                                        )
                                                                    }}
                                                                />
                                                            </MuiPickersUtilsProviderPadrao>
                                                        </GridItem3>

                                                        <GridItem1
                                                            align='right'
                                                            className='mt-5'
                                                        >
                                                            <IconButtonMoveParaCimaParaBaixo
                                                                array={values.anotacoes}
                                                                nomeArray={'anotacoes'}
                                                                setFieldValue={setFieldValue}
                                                                ind={ind}
                                                                disabled={values.ultimaVersao !== values.versao}
                                                            />
                                                        </GridItem1>
                                                    </GridContainer>

                                                    <GridContainer>
                                                        <GridItem11>
                                                            <RichTextEditorPadrao
                                                                name={`anotacoes[${ind}].richText`}
                                                                content={item.richText}
                                                                setFieldValue={setFieldValue}
                                                                disabled={values.ultimaVersao !== values.versao}
                                                            />
                                                        </GridItem11>
                                                        <GridItem1>
                                                            <IconButtonClearEntradaDados
                                                                onClick={() =>
                                                                    arrayHelpers.remove(ind)
                                                                }
                                                                disabled={values.ultimaVersao !== values.versao}
                                                            />
                                                        </GridItem1>
                                                    </GridContainer>
                                                </CardGridDivBodyEntradaDados>
                                            </CardGridEntradaDados>
                                        </GridItem12>
                                    </GridContainer>
                                )
                            })}
                        </DivForm>

                        <GridContainer>
                            <ButtonIncluirLinha
                                label={LABEL.buttonIncluirAnotacao} 
                                onClick={() => 
                                    arrayHelpers.push({
                                        tituloAnotacao: '',
                                        dataAnotacao: null,
                                        richText: '',
                                    })
                                }
                            />
                        </GridContainer>
                    </DivForm>
                )}
            </FieldArray>
        </ValidatorForm>
    )
}

export default AcompanhamentoFormAnotacoes